// Web Development Task & Performance Tracker — single source of truth (frontend only)

export const TASK_STATUSES = [
  'To Do',
  'In Development',
  'In QA',
  'Client Review',
  'Completed',
  'Blocked',
  'Delayed'
];

export const ADMIN_VERDICTS = ['', 'Accepted', 'Needs Rework', 'Escalated'];

export const users = [
  { id: 1, name: 'Yusuff Sir', role: 'admin' },
  { id: 2, name: 'Srinivasan', role: 'member' },
  { id: 3, name: 'Boomiga', role: 'member' },
  { id: 4, name: 'Sowmiya', role: 'member' },
  { id: 5, name: 'Yoga', role: 'member' },
  { id: 6, name: 'Yogitha', role: 'member' },
  { id: 7, name: 'RajaKannathasan', role: 'member' }
];

// Task schema: taskName, clientName, projectName, estimatedTime, taskDescription,
// assignedMember (userName), userId, plannedStartDate, plannedEndDate, currentStatus,
// delayReason (required when Delayed), actualTime, completionDate, adminRemarks, adminVerdict
export let tasks = [];

function nextId() {
  if (tasks.length === 0) return 1;
  return Math.max(...tasks.map(t => t.id)) + 1;
}

export function getTasks() {
  return [...tasks];
}

export function getTasksByUserId(userId) {
  return tasks.filter(task => task.userId === userId);
}

export function getTasksByUserName(userName) {
  return tasks.filter(task => task.assignedMember === userName || task.userName === userName);
}

export function addTask(taskData) {
  const id = nextId();
  const newTask = {
    id,
    userName: taskData.assignedMember || taskData.userName,
    userId: taskData.userId,
    ...taskData
  };
  if (!newTask.assignedMember) newTask.assignedMember = newTask.userName;
  tasks.push(newTask);
  return newTask;
}

export function updateTask(taskId, updatedData) {
  const index = tasks.findIndex(task => task.id === taskId);
  if (index === -1) return null;
  tasks[index] = { ...tasks[index], ...updatedData };
  if (tasks[index].currentStatus === 'Completed' && !tasks[index].completionDate) {
    tasks[index].completionDate = new Date().toISOString().split('T')[0];
  }
  return tasks[index];
}

export function getUsers() {
  return [...users];
}

// Derived: task is on time if Completed and completionDate <= plannedEndDate (and not Delayed)
export function isTaskOnTime(task) {
  if (task.currentStatus === 'Delayed') return false;
  if (task.currentStatus !== 'Completed') return null; // in progress
  if (!task.completionDate || !task.plannedEndDate) return null;
  return task.completionDate <= task.plannedEndDate;
}
